import type { VariantProps } from '@simplywallst/ui-core/next';
import { tv } from '@simplywallst/ui-core/next';

interface Props {
  percent: number;
  percentWarnLimit?: number;
}

const indicator = tv({
  base: 'fill-none [transition:stroke-dashoffset_0.2s,stroke_0.4s]',
  variants: {
    status: {
      default: 'stroke-p-white-100/10',
      good: 'stroke-brand-01',
      warning: 'stroke-warning',
      complete: 'stroke-bad',
    },
  },
  defaultVariants: {
    status: 'default',
  },
});
type IndicatorStatus = VariantProps<typeof indicator>['status'];

export const Indicator = ({ percent, percentWarnLimit }: Props) => {
  const initDashoffset = 56.27054;
  const strokeDasharray = initDashoffset;
  const strokeDashoffset = initDashoffset - initDashoffset * percent;

  let status: IndicatorStatus = 'good';

  if (typeof percentWarnLimit !== 'undefined' && percent >= percentWarnLimit) {
    status = 'warning';
  }

  if (percent === 1) {
    status = 'complete';
  }

  return (
    <div
      role="progressbar"
      aria-valuemin={0}
      aria-valuemax={100}
      aria-valuenow={percent * 100}
      className="-rotate-90"
    >
      <svg height="100%" viewBox="0 0 20 20" width="100%">
        <circle
          className={indicator()}
          strokeWidth="2px"
          strokeLinecap="round"
          r={9}
          cx="50%"
          cy="50%"
        />
        <circle
          className={indicator({ status })}
          strokeWidth="2px"
          strokeLinecap="round"
          r={9}
          cx="50%"
          cy="50%"
          strokeDashoffset={strokeDashoffset}
          strokeDasharray={strokeDasharray}
        />
      </svg>
    </div>
  );
};
